import { render, staticRenderFns } from "./DepartmentSelector.vue?vue&type=template&id=5602d4ba"
import script from "./DepartmentSelector.vue?vue&type=script&lang=js"
export * from "./DepartmentSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports